import React, { memo } from 'react';
import { Platform, TouchableOpacity, View, Text } from 'react-native';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, InterestBounceType, TypographyTypeDLS, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { Icon } from '../icon/Icon';
import { Typography } from '../typography/Typography';
import { Button } from '../button/Button';
import { isMobile, isMobileView, isMobileViewApp } from '../stack/utils';
import { addCommasToNumber } from '../pages/utils';
import moment from 'moment';
import { LENDER_ID } from "../pages/constants";
const InterestRepaymentCard = ({ viewDetailAction, triggerAction, type, interestRepaymentData, backAction, bankDetail, learnMoreAction, isFromTata, lenderId }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    let softBreachDate = lenderId.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? 3 : lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? 7 : 7;
    let hardBreachDate = lenderId.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? 15 : lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? 15 : 15;
    const currentMonth = moment().format('MMMM');
    const areOnlyChargesDue = interestRepaymentData.outstandingInterest === 0 && interestRepaymentData.outStandingCharges !== 0;
    const isFromMobileViewApp = isMobileViewApp();
    const _isFontMobile = () => {
        if (Platform.OS !== 'web') {
            return true;
        }
        else if (isFromMobileViewApp) {
            return true;
        }
        else {
            return false;
        }
    };
    const isFontMobile = _isFontMobile();
    const getDescription = (type) => {
        switch (type) {
            case InterestBounceType.NORMAL:
                return React.createElement(View, { style: {
                        backgroundColor: '#FDF7E7',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomRightRadius: 12,
                        borderBottomLeftRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.LG }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Text, null,
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Auto debit on`, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ` ${softBreachDate}-${currentMonth}`, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `, Ensure balance of `, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: isMobile ? `₹${addCommasToNumber(interestRepaymentData.totalAmount)}\n` : `₹${addCommasToNumber(interestRepaymentData.totalAmount)} `, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `in ${bankDetail.bankName} ${bankDetail?.accountNumber?.slice(-4)}`, color: ColorTokens.Grey_Night }),
                                    type === InterestBounceType.DATE_BREACHED && React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Need help?' }))),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    if (backAction) {
                                        triggerAction(backAction);
                                    }
                                } }, type === InterestBounceType.DATE_BREACHED && React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Contact support', color: ColorTokens.Primary_100 })))));
            case InterestBounceType.DATE_BREACHED:
                return React.createElement(View, { style: {
                        backgroundColor: '#FDF7E7',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomRightRadius: 12,
                        borderBottomLeftRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.LG }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Text, null,
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'We are processing auto-debit.', color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? ' It may take up to 2\nbusiness days. Need help?' : ' It may take up to 2 business days.\nNeed help?' }),
                                    React.createElement(TouchableOpacity, { onPress: () => {
                                            if (backAction) {
                                                triggerAction(backAction);
                                            }
                                        } },
                                        React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ' Contact us', color: ColorTokens.Primary_100 }))))))));
            case InterestBounceType.BOUNCED:
                return React.createElement(View, { style: {
                        backgroundColor: '#FFF8F8',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomRightRadius: 12,
                        borderBottomLeftRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.XL, color: ColorTokens.System_Error }),
                        React.createElement(View, { style: { marginLeft: 8, flexDirection: 'row' } },
                            React.createElement(Text, { style: { flexShrink: 1 } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: `Last auto-debit failed! `, color: ColorTokens.Grey_Night }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Pay by `, color: ColorTokens.Grey_Night }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: `${hardBreachDate}-${currentMonth}`, color: ColorTokens.Grey_Night }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: ` to avoid\ndefaulting   `, color: ColorTokens.Grey_Night }),
                                !areOnlyChargesDue && React.createElement(TouchableOpacity, { onPress: () => {
                                        if (learnMoreAction) {
                                            triggerAction(learnMoreAction);
                                        }
                                    } },
                                    React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ' Learn more', color: ColorTokens.Primary_100 })))))));
            case InterestBounceType.HARD_DATE_BREACHED:
                return React.createElement(View, { style: {
                        backgroundColor: '#FFF8F8',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomLeftRadius: 12,
                        borderBottomRightRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.XL }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row', } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Your interest is still overdue. Need help?', color: ColorTokens.Grey_Night })),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    if (backAction) {
                                        triggerAction(backAction);
                                    }
                                } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Contact support', color: ColorTokens.Primary_100 })))));
        }
    };
    const getDescriptionForMandate = (type) => {
        switch (type) {
            case InterestBounceType.NORMAL:
                return React.createElement(View, { style: {
                        backgroundColor: '#FDF7E7',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomRightRadius: 12,
                        borderBottomLeftRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.LG }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Text, null,
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Pay by`, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ` ${softBreachDate}-${currentMonth}`, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: ` to avoid penalty charges`, color: ColorTokens.Grey_Night }))))));
            case InterestBounceType.DATE_BREACHED:
                return React.createElement(View, { style: {
                        backgroundColor: '#FFF8F8',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomRightRadius: 12,
                        borderBottomLeftRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.XL }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Text, null,
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Pay by`, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ` ${hardBreachDate}-${currentMonth}`, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: ` to avoid defaulting`, color: ColorTokens.Grey_Night }))),
                            !areOnlyChargesDue && React.createElement(TouchableOpacity, { onPress: () => {
                                    if (learnMoreAction) {
                                        triggerAction(learnMoreAction);
                                    }
                                } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Learn more', color: ColorTokens.Primary_100 })))));
            case InterestBounceType.BOUNCED:
                return React.createElement(View, { style: {
                        backgroundColor: '#FFF8F8',
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        borderBottomRightRadius: 12,
                        borderBottomLeftRadius: 12
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.XL }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Your interest is still overdue. Need help?', color: ColorTokens.Grey_Night })),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    if (backAction) {
                                        triggerAction(backAction);
                                    }
                                } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Contact support', color: ColorTokens.Primary_100 })))));
            case InterestBounceType.HARD_DATE_BREACHED:
                return React.createElement(View, { style: {
                        backgroundColor: '#FFF8F8',
                        paddingVertical: 8,
                        paddingHorizontal: 16
                    } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.XL }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Your interest is still overdue. Need help?', color: ColorTokens.Grey_Night })),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    if (backAction) {
                                        triggerAction(backAction);
                                    }
                                } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Contact support', color: ColorTokens.Primary_100 })))));
        }
    };
    const InterestRepaymentCard = () => {
        return (React.createElement(View, { style: {
                borderRadius: 12,
                borderWidth: 1,
                borderColor: type === InterestBounceType.HARD_DATE_BREACHED || type === InterestBounceType.BOUNCED ? '#FFF8F8' : colorMapping[ColorTokens.Grey_Chalk],
                backgroundColor: colorMapping[ColorTokens.White],
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    padding: 16,
                } },
                React.createElement(View, null,
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: type === InterestBounceType.HARD_DATE_BREACHED || type === InterestBounceType.BOUNCED || (!interestRepaymentData.isMandateSetup && !InterestBounceType.NORMAL) ? 'Amount overdue' : 'Amount due', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: `₹${addCommasToNumber(interestRepaymentData.totalAmount)}` })),
                React.createElement(TouchableOpacity, { style: { width: Platform.OS !== 'web' ? 150 : 100 }, onPress: () => {
                        if (viewDetailAction) {
                            triggerAction(viewDetailAction);
                        }
                    } },
                    React.createElement(Button, { onPress: () => {
                            if (viewDetailAction) {
                                triggerAction(viewDetailAction);
                            }
                        }, typeDLS: !interestRepaymentData?.isMandateSetup && interestRepaymentData.repaymentAllowed || (type == InterestBounceType.BOUNCED || type === InterestBounceType.HARD_DATE_BREACHED) && interestRepaymentData.repaymentAllowed ? ButtonTypeDLS.PRIMARY : ButtonTypeDLS.SECONDARY, sizeDLS: ButtonSizeDLS.SMALL, label: !interestRepaymentData?.isMandateSetup && interestRepaymentData.repaymentAllowed || (type == InterestBounceType.BOUNCED || type === InterestBounceType.HARD_DATE_BREACHED) && interestRepaymentData.repaymentAllowed ? 'Pay now' : "View details" }))),
            React.createElement(View, { style: { height: 0.5, backgroundColor: '#E4E7EC', } }),
            interestRepaymentData.isMandateSetup ? getDescription(type) : getDescriptionForMandate(type)));
    };
    return (React.createElement(View, { style: {
            width: '100%',
            marginBottom: 16,
            marginTop: 16
        } }, InterestRepaymentCard()));
};
export default memo(InterestRepaymentCard);
export { InterestRepaymentCard };
